import React, { useEffect } from 'react';

import {
  useRestrictedActionFormState,
  useRestrictedActionFormActions,
} from './RestrictedActionFormContext';

import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const RestrictedActionForm = ({ restrictedAction, onSubmit, onCancel }) => {
  const state = useRestrictedActionFormState();
  const {
    initializeState,
    updateForm,
    updateGroupId,
    updateRestrictedActionName,
    updateResourceId,
    updateResourceType,
    updateApplyToAllUsers,
    onResponse,
    onError,
  } = useRestrictedActionFormActions();

  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  useEffect(() => {
    if (restrictedAction) {
      updateForm(restrictedAction);
    } else {
      initializeState();
    }
  }, []);

  const handleSubmit = () => {
    onSubmit({
      restrictedAction,
      onResponse,
      onError,
      body: {
        restrictedActionForm: state?.restrictedActionForm,
        authenticity_token: authenticityToken,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="Group Id" id="groupId">
        <Input
          type="text"
          value={state?.restrictedActionForm?.groupId || ''}
          onChange={(e) => updateGroupId(e.target.value)}
        />
      </Field>

      <Field label="Restricted Action Name" id="restrictedActionName">
        <Input
          type="text"
          value={state?.restrictedActionForm?.restrictedActionName || ''}
          onChange={(e) => updateRestrictedActionName(e.target.value)}
        />
      </Field>

      <Field label="Resource Id" id="resourceId">
        <Input
          type="text"
          value={state?.restrictedActionForm?.resourceId || ''}
          onChange={(e) => updateResourceId(e.target.value)}
        />
      </Field>

      <Field label="Resource Type" id="resourceType">
        <Input
          type="text"
          value={state?.restrictedActionForm?.resourceType || ''}
          onChange={(e) => updateResourceType(e.target.value)}
        />
      </Field>

      <Field label="Apply To All Users" id="applyToAllUsers">
        <Input
          type="text"
          value={state?.restrictedActionForm?.applyToAllUsers || ''}
          onChange={(e) => updateApplyToAllUsers(e.target.value)}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => {
              if (onCancel) {
                onCancel();
              }
            }}
          >
            Cancel
          </Button>
          <Button type="submit">
            {!!restrictedAction ? 'Update Restricted Action' : 'Create Restricted Action'}
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default RestrictedActionForm;
